import React, { useState } from 'react'
import './Content.css'
import Partners from './Components/Cards/Partners'
import cardsData from '../../Componentes/DataPartners';
const Content = () => {
  const [searchInput, setSearchInput] = useState('');
  const handleSearchChange = (e) => {
    setSearchInput(e.target.value);
  };
  const filteredCardsData = cardsData.filter(card =>
    card.companyName.toLowerCase().includes(searchInput.toLowerCase()) ||
    card.companyCountry.toLowerCase().includes(searchInput.toLowerCase()) ||
    card.companyAbout.toLowerCase().includes(searchInput.toLowerCase()) ||
    card.classification.toLowerCase().includes(searchInput.toLowerCase())
  );
  const totalData= cardsData.length;
  return (
    <div className='container container-content'>
        <h1 className='title-partners'>Chatby Partners</h1>
        <div className="undertitle">
            <p>Encuentre el socio perfecto para satisfacer las necesidades de su negocio. Los socios dedicados de Chatby lo ayudarán a crear e implementar soluciones de automatización, optimizar procesos, atender a sus clientes y mucho más.
            </p>
        </div>
        <div className="container-search">
          <div className="div-search">
            <input
                name="searchInput"
                id="searchInput"
                type="text"
                placeholder="Search"
                className="searchInput"
                value={searchInput}
                onChange={handleSearchChange}
              />          
          </div>
        </div>
        <Partners filteredCardsData={filteredCardsData} totalData={totalData} />
    </div>
  )
}

export default Content